<template>
  <section v-if="archivedConversation">
    <div class="card mb-3">
      <div class="card-body p-2">
        <div class="row">
          <div class="col-lg-3 text-small">
            {{ archivedConversation.name }}
          </div>
          <div class="col-lg-9">
            <b-button
              variant="info"
              :class="visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4"
              @click="visible = !visible"
            >
              ดูบทสนทนา
            </b-button>
            <b-collapse id="collapse-4" v-model="visible" class="mt-2">
              <section class="bg-white" v-if="conversations">
                <div class="mb-3" v-for="(conversation, index) in conversations" :key="index">
                  <div class="d-flex justify-content-start align-items-center" v-if="conversation.type === 'User'">
                    <div class="mr-2">
                      <img
                        src="https://www.flaticon.com/svg/vstatic/svg/149/149071.svg?token=exp=1612173340~hmac=fef56aa21b220ef9639bb42a533c3ef0"
                        width="36" />
                    </div>
                    <div style="margin-right: 25%;">
                      <div class="rounded p-2 customer-chat text-small">{{ conversation.message }}</div>
                      <div class="text-smaller text-secondary mt-1">{{ conversation.date }} - {{ conversation.time }}</div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end align-items-center" v-else>
                    <div style="margin-left: 25%;">
                      <div class="rounded p-2 admin-chat text-small">{{ conversation.message }}</div>
                      <div class="text-right text-smaller text-secondary mt-1">{{ conversation.date }} - {{ conversation.time }}</div>
                    </div>
                    <div>
                      <img src="https://www.flaticon.com/premium-icon/icons/svg/1042/1042189.svg" width="36"
                           class="ml-2" />
                    </div>
                  </div>
                </div>
              </section>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    archivedConversation: Object
  },
  data () {
    return {
      visible: false,
      conversations: null
    }
  },
  mounted () {
    if (this.archivedConversation && this.archivedConversation.content) {
      try {
        this.conversations = JSON.parse(this.archivedConversation.content)
      } catch (e) {
        this.conversations = null
      }
    }
  }
}
</script>
